// tslint:disable-next-line:no-shadowed-variable
import { ConfigModel } from '../core/interfaces/config';

// tslint:disable-next-line:no-shadowed-variable
export class MenuConfig implements ConfigModel {
  public config: any = {};

  PREFIX_URL = '/pages';

  constructor() {
    this.config = {
      header: {
        self: {},
        items: [
          {
            title: 'Menu de exemplo',
            root: true,
            icon: 'flaticon-add',
            toggle: 'click',
            translate: 'MENU.ACTIONS',
          },
        ]
      },
      aside: {
        self: {},
        items: [
          {
            title: 'Roteirização',
            root: true,
            icon: 'la la-map',
            page: `${this.PREFIX_URL}/roteirizacao`
          },
          {
            title: 'Consultas',
            root: true,
            bullet: 'dot',
            icon: 'la la-search',
            submenu: [
              {
                title: 'Romaneios',
                root: true,
                icon: 'las la-truck-loading',
                page: this.PREFIX_URL + '/consultas/romaneios',
              },
              {
                title: 'Carregamentos',
                root: true,
                icon: 'la la-truck',
                page: this.PREFIX_URL + '/consultas/carregamentos',
              },
              {
                title: 'Painel de carga automática',
                root: true,
                icon: 'la la-play-circle',
                page: `${this.PREFIX_URL}/carga-automatica`
              },
              {
                title: 'Falha Geocode',
                root: true,
                icon: 'la la-times-circle',
                page: `${this.PREFIX_URL}/consultas/falha-geocode`,
              }
            ]
          },
          {
            title: 'Dashboard',
            root: true,
            bullet: 'dot',
            icon: 'la la-bar-chart',
            submenu: [
              {
                title: 'Indicadores de uso',
                root: true,
                icon: 'la la-truck',
                page: `${this.PREFIX_URL}/dashboard/inidicadores-de-uso`
              },
              {
                title: 'Pedidos prontos para montagem',
                root: true,
                icon: 'la la-check-square',
                page: `${this.PREFIX_URL}/dashboard/pedidos-prontos-montagem`
              }
            ]
          },
          {
            title: 'Cadastros',
            root: true,
            bullet: 'dot',
            icon: 'la la-pencil',
            submenu: [
              {
                title: 'Filiais',
                root: true,
                icon: 'far fa-building',
                page: `${this.PREFIX_URL}/cadastros/filiais`
              },
              {
                title: 'Centro de Distribuição',
                root: true,
                icon: 'la la-building',
                page: `${this.PREFIX_URL}/cadastros/centro-distribuicao`,
              },
              {
                title: 'Clientes',
                root: true,
                icon: 'la la-users',
                page: `${this.PREFIX_URL}/cadastros/clientes`,
              },
              {
                title: 'Ramo de atividade',
                root: true,
                bullet: 'dot',
                icon: 'fas fa-briefcase',
                page: `${this.PREFIX_URL}/cadastros/ramo-atividade`
              },
              {
                title: 'Motoristas',
                root: true,
                icon: 'fas fa-user-tie',
                page: `${this.PREFIX_URL}/cadastros/motoristas`
              },
              {
                title: 'Ajudantes',
                root: true,
                icon: 'fas fa-user',
                page: `${this.PREFIX_URL}/cadastros/ajudantes`
              },
              {
                title: 'Combustível',
                root: true,
                icon: 'fas fa-gas-pump',
                page: `${this.PREFIX_URL}/cadastros/combustiveis`
              },
              {
                title: 'Tipo de Veículo',
                root: true,
                icon: 'la la-truck',
                page: `${this.PREFIX_URL}/cadastros/tipo-veiculo`
              },
              {
                title: 'Caracteristica do veículo',
                root: true,
                icon: 'las la-truck-pickup',
                page: `${this.PREFIX_URL}/cadastros/veiculo-caracteristica`
              },
              {
                title: 'Veículos',
                root: true,
                icon: 'fas fa-car-side',
                page: `${this.PREFIX_URL}/cadastros/veiculos`
              },
              {
                title: 'Rotas',
                root: true,
                icon: 'la la-road',
                page: `${this.PREFIX_URL}/cadastros/rotas`,
              },
              {
                title: 'Motivo',
                root: true,
                bullet: 'dot',
                icon: 'fas fa-pen',
                submenu: [
                  {
                    title: 'Transferência',
                    icon: 'fas fa-exchange-alt',
                    page: `${this.PREFIX_URL}/cadastros/motivo-transferencia`
                  },
                ]
              },
              {
                title: 'Tabela Frete',
                root: true,
                icon: 'fas fa-donate',
                page: `${this.PREFIX_URL}/cadastros/tabela-frete`
              },
              {
                title: 'Ponto de Parada',
                root: true,
                icon: 'far fa-hand-paper',
                page: `${this.PREFIX_URL}/cadastros/ponto-parada`
              },
              {
                title: 'Áreas de Atendimento',
                root: true,
                icon: 'fa fa-object-group',
                page: `${this.PREFIX_URL}/cadastros/areas-clientes`
              },
              {
                title: 'Regiões de Atendimento',
                root: true,
                icon: 'fas fa-map',
                page: `${this.PREFIX_URL}/cadastros/regioes-atendimento`
              },
              {
                title: 'Solicitação de Entrega/Coleta',
                root: true,
                bullet: 'dot',
                icon: 'fas fa-pallet',
                page: `${this.PREFIX_URL}/cadastros/entrega-avulsa`
              },
              {
                title: 'Palavras Chave',
                root: true,
                bullet: 'dot',
                icon: 'fas fa-key',
                page: `${this.PREFIX_URL}/cadastros/palavras-chaves`
              },
              {
                title: 'Identificação Personalizada',
                icon: 'fa fa-star',
                page: `${this.PREFIX_URL}/cadastros/identificacao-personalizada`
              },
              {
                title: 'Carga automática',
                icon: 'la la-road',
                page: `${this.PREFIX_URL}/cadastros/complemento-rotas`,
              },
              {
                title: 'Transportadoras',
                icon: 'fas fa-truck',
                page: `${this.PREFIX_URL}/cadastros/transportadora`
              },
              {
                title: 'Praças de Pedágio',
                icon: 'fa fa-arrow-up',
                page: `${this.PREFIX_URL}/cadastros/sem-parar`
              },
              {
                title: 'Fornecedor/Emitente',
                root: true,
                bullet: 'dot',
                icon: 'fas fa-industry',
                page: `${this.PREFIX_URL}/cadastros/fornecedor-emitente`
              },
            ]
          },
          {
            title: 'Relatórios',
            root: true,
            bullet: 'dot',
            icon: 'la la-edit',
            submenu: [
              {
                title: 'Resumo de montagem',
                root: true,
                page: `${this.PREFIX_URL}/relatorios/resumo-montagem`
              },
              {
                title: 'Lucratividade por Romaneio',
                root: true,
                page: `${this.PREFIX_URL}/relatorios/lucratividade-por-romaneio`
              },
              {
                title: 'Custo por Romaneio',
                root: true,
                page: `${this.PREFIX_URL}/relatorios/custo-por-romaneio`
              },
              {
                title: 'Extrato de Custo por Transportadora',
                root: true,
                page: `${this.PREFIX_URL}/relatorios/custo-por-transportadora`
              },
              {
                title: 'Embarque de veículo',
                root: true,
                page: `${this.PREFIX_URL}/relatorios/embarque-veiculo`
              },
            ]
          },
          {
            title: 'Importar Arquivo',
            root: true,
            bullet: 'dot',
            icon: 'la la-file-code-o',
            submenu: [
              {
                title: 'XML',
                icon: 'fa fa-file-import',
                page: `${this.PREFIX_URL}/importar-xml`
              },
              {
                title: 'EXCEL',
                icon: 'far fa-file-excel',
                page: `${this.PREFIX_URL}/importar-excel`
              },
              {
                title: 'Consultar Notas Fiscais',
                icon: 'la la-times-circle-o',
                page: `${this.PREFIX_URL}/ferramentas/consultar-nfs-importadas`
              },
            ]
          },
          {
            title: 'Autorizações',
            root: true,
            bullet: 'dot',
            icon: 'fa fa-check-double',
            page: `${this.PREFIX_URL}/autorizacoes`
          },
          {
            title: 'Mapas',
            bullet: 'dot',
            icon: 'la la-map-pin',
            submenu: [
              {
                title: 'Visualizar Clientes',
                bullet: 'dot',
                icon: 'la la-users',
                page: `${this.PREFIX_URL}/mapa-clientes`
              },
            ]
          },
          {
            title: 'Configurações',
            bullet: 'dot',
            icon: 'la la-cog',
            submenu: [
              {
                title: 'Usuários',
                icon: 'la la-user',
                page: `${this.PREFIX_URL}/configuracoes/usuario`
              },
              {
                title: 'Perfil de Acesso',
                icon: 'la la-user',
                page: `${this.PREFIX_URL}/configuracoes/perfis-acesso`
              },
              {
                title: 'Logo da Empresa',
                icon: 'la la-file-image-o',
                page: `${this.PREFIX_URL}/ferramentas/logo-empresa`
              },
              {
                title: 'Geração de coordenadas/Geocode',
                icon: 'la la-exchange',
                page: `${this.PREFIX_URL}/ferramentas/localizacao-erp`
              },
              {
                title: 'Portal',
                icon: 'la la-cog',
                page: `${this.PREFIX_URL}/configuracoes/parametros-portal`
              },
              {
                title: 'Certificados Digitais',
                icon: 'la la-certificate',
                page: `${this.PREFIX_URL}/configuracoes/certificados-digitais`
              },
              {
                title: 'Vale Pedágio',
                icon: 'fa fa-road',
                page: `${this.PREFIX_URL}/configuracoes/vale-pedagio`
              },
            ]
          },
          {
            title: 'Central de Atualizações',
            root: true,
            icon: 'icon-central-atualizacoes',
            dialog: true,
            page: '',
          },
          {
            title: 'MaxInsights',
            root: true,
            bullet: 'dot',
            icon: 'icon-maxinsights',
            page: '',
            dialog: true,
						isExternalLink: true,
            bannerLink: 'https://conteudos.maximatech.com.br/maxinsights',
						bannerImagePath: './assets/img/maxinsights/banner.png',
            msgSemAcesso: ''
          },
        ]
      }
    };
  }
}
